import React, { Component } from "react"
import { Forms } from "../../styleguide/js/components/forms"
import DatePickerPikaday from "../../styleguide/js/components/datepicker-pikaday"
import * as dateHelper from "../../booking/helpers/date"
import { isMobile } from "react-device-detect"

class FlightSearchForm extends Component {
  constructor(props) {
    super(props)
    this.dateTextBoxRef = React.createRef()
    this.formRef = React.createRef()
    this.datePicker = undefined
  }

  componentDidMount() {
    // const queryString = QueryString.parse(window.location.search)
    // if (queryString.q) this.setState({ query: queryString.q })
    if (this.dateTextBoxRef.current && !this.datePicker) {
      this.datePicker = new DatePickerPikaday({ el: this.dateTextBoxRef.current })
      this.setDateInDatePicker = this.datePicker.getPicker().setDate
    }
    if (this.formRef.current) new Forms({ el: this.formRef.current })
  }

  componentWillUnmount() {
    delete this.formRef.current
  }

  componentDidUpdate(prevProps) {
    if (prevProps.activeTab !== this.props.activeTab) {
      this.datePicker.getPicker().destroy()
      delete this.datePicker
      this.dateTextBoxRef.current.classList.remove("is-bound") // forces datepicker re-initialization
      this.datePicker = new DatePickerPikaday({ el: this.dateTextBoxRef.current })
    }
  }

  render() {
    const { config, minDate, query, time, activeTab, selectedDate, departingFlightId } = this.props
    if (this.setDateInDatePicker && selectedDate) {
      try {
        this.datePicker.selectedDate = new Date(Date.parse(selectedDate))
      } catch {
        console.log("Error parsing date")
      }
    }
    const formattedDate = dateHelper.formatDate(selectedDate, "DD / MM / YYYY", "da")

    const showSkipStep = activeTab !== 1 && departingFlightId?.length > 0
    return (
      <div className="form flights__header__form js--form" ref={this.formRef}>
        <div className="w--wider">
          {showSkipStep ? (
            <div className="form__section align-right v--mobile-only">
              <div>
                <button className="simple-link " onClick={() => this.props.writeToState(activeTab === 2 ? { activeStep: 2 } : { activeTab: 2 })}>
                  Spring over
                </button>
              </div>
            </div>
          ) : null}
          <div className="form__section">
            <div className="form__section__inner">
              <div className="form__field form__field--text form__field--text-search  form__field--text--no-label">
                <span className="form__valid" />
                <input
                  className="form__item "
                  id="searchTextbox"
                  type="text"
                  value={query}
                  placeholder={config.searchPlaceholderText || "Søg på by, flyselskab eller flynummer... "}
                  onChange={(e) => this.props.queryChangeHandler(e.currentTarget.value, activeTab)}
                  onFocus={(e) =>
                    isMobile && e.currentTarget.scrollIntoView && e.currentTarget.scrollIntoView({ behavior: "smooth", block: "start" })
                  }
                />
                <button onClick={(e) => this.props.searchClickHandler(e)}>
                  <span className="icon">
                    <svg className="svg-icon svg-icon--search">
                      <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-search">
                        &nbsp;
                      </use>
                    </svg>
                  </span>
                </button>
              </div>
            </div>
          </div>
          <div className="form__section form__section--split">
            <div className="form__section__inner">
              <div
                ref={this.dateTextBoxRef}
                className="form__field form__field--date form__field--date--pikaday rm-this-class-hide-default is-filled"
              >
                <input
                  className="form__item"
                  id="DateTextBox"
                  min={minDate}
                  value={formattedDate}
                  readOnly
                  type="text"
                  onBlur={(e) => this.props.dateChangeHandler(e.currentTarget.value)}
                />
              </div>
            </div>
            <div className="form__section__inner">
              <div className="form__field form__field--select is-filled">
                <div className="form__container">
                  <span className="form__valid" />
                  <select
                    id="select"
                    className="form__item "
                    aria-label="Select menu"
                    value={time}
                    onChange={(e) => this.props.timeChangeHandler(e.currentTarget.value)}
                  >
                    {config.timeSelectList.map((item, index) => (
                      <option key={index} value={item.value}>
                        {item.text}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div className="form__section v--desktop-only">
            {/* <button className="button button--medium button--general rm-this-class rm-this-class-hide-default" >
                            <span className="icon">
                                <svg className="svg-icon svg-icon--planeduo">
                                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-planeduo">&nbsp;</use>
                                </svg>
                            </span>
                            <span className="text">{config.searchButtonText || 'Søg'}</span>
                        </button> */}
          </div>
        </div>
      </div>
    )
  }
}
export default FlightSearchForm
